import "core-js/modules/web.dom-collections.iterator.js";
import { render, within } from "@testing-library/react";
import i18next from "i18next";
import Terria from "../../../../lib/Models/Terria";
import SearchResults from "../../../../lib/ReactViews/Tools/ItemSearchTool/SearchResults";
import MockSearchableItem from "./MockSearchableItem";
import { jsx as _jsx } from "react/jsx-runtime";
describe("SearchResults", function () {
  beforeAll(async () => {
    await i18next.changeLanguage("en");
  });
  afterAll(async () => {
    await i18next.changeLanguage("cimode");
  });
  it("shows the results count", async function () {
    const {
      container
    } = render(/*#__PURE__*/_jsx(SearchResults, {
      item: new MockSearchableItem(undefined, new Terria()),
      results: sampleResults(20)
    }));
    expect(within(container).getByText("20 matches found")).toBeVisible();
  });
});
function sampleResults(count) {
  return [...Array(count)].map((_, i) => ({
    id: "building-".concat(i),
    idPropertyName: "building-id",
    featureCoordinate: {
      latitudeDegrees: 45,
      longitudeDegrees: 100,
      featureHeight: 200
    },
    properties: {
      name: "bldg-".concat(i)
    }
  }));
}